import {
  getAllContacts,
  createContact,
  createAllContacts,
  updateContact,
  deleteContact,
} from '@/services/contact';

const state = {
  contacts: [],
  processed: false,
};

const getters = {
  getContacts(state) {
    return state.contacts;
  },
  contactProcessed(state) {
    return state.processed;
  },
};

const actions = {
  fetchContacts({ commit }, params) {
    commit('SET_PROCESSING');
    return new Promise((resolve, reject) => {
      getAllContacts(params)
        .then((response) => {
          commit('SET_CONTACTS', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createContact({ commit }, contact) {
    return new Promise((resolve, reject) => {
      createContact(contact)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createAllContacts({ commit }, contacts) {
    return new Promise((resolve, reject) => {
      createAllContacts(contacts)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateContact({ commit }, contact) {
    return new Promise((resolve, reject) => {
      updateContact(contact)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteContact({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteContact(id)
        .then((response) => {
          commit('SET_PROCESSED');
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_CONTACTS(state, data) {
    state.contacts = data;
    state.processed = true;
  },
  SET_PROCESSING(state) {
    state.processed = false;
  },
  SET_PROCESSED(state) {
    state.processed = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
